import { atom } from 'jotai'
import { UserDetails } from '../types/userDetails.types'

export const userAtom = atom<UserDetails | null>(null)
